import { CategoryType } from '@core/shared/domain';

import {
  ArticleRangeFilterType,
  FieldArticleRangeFilterOperator,
  GroupArticleRangeFilterOperator,
  _EmptyFilters,
  _FieldArticleRangeFilterType,
} from '../models';

interface TypeDescription {
  icon: string;
  label: string;
}

/**
 * Empty filter type to start the editor with.
 */
export const defaultTypeForEmptyFilter: ArticleRangeFilterType.Supplier = ArticleRangeFilterType.Supplier;

/**
 * The max depth of the editor (`-1` for no limit).
 */
export const maxDepth = 2;

/**
 * The default empty filters per type
 */
export const emptyFilters: _EmptyFilters = {
  [ArticleRangeFilterType.Group]: {
    type: ArticleRangeFilterType.Group,
    operator: GroupArticleRangeFilterOperator.Or,
    children: [],
  },
  [ArticleRangeFilterType.Category]: {
    type: ArticleRangeFilterType.Category,
    categoryType: CategoryType.ECLASS,
    operator: FieldArticleRangeFilterOperator.Equals,
  },
  [ArticleRangeFilterType.Manufacturer]: {
    type: ArticleRangeFilterType.Manufacturer,
    operator: FieldArticleRangeFilterOperator.Equals,
  },
  [ArticleRangeFilterType.Supplier]: {
    type: ArticleRangeFilterType.Supplier,
    operator: FieldArticleRangeFilterOperator.Equals,
  },
};

/**
 * The descriptions to use for the options.
 */
export const typeDescriptions: Record<_FieldArticleRangeFilterType, TypeDescription> = {
  [ArticleRangeFilterType.Category]: {
    label: 'Warengruppe',
    icon: 'category',
  },
  [ArticleRangeFilterType.Manufacturer]: {
    label: 'Hersteller',
    icon: 'precision_manufacturing',
  },
  [ArticleRangeFilterType.Supplier]: {
    label: 'Lieferant',
    icon: '@truck_outline',
  },
};

/**
 * Labels for the group operators, used in the select box.
 */
export const groupOperatorLabels: Record<GroupArticleRangeFilterOperator, string> = {
  [GroupArticleRangeFilterOperator.And]: 'und',
  [GroupArticleRangeFilterOperator.Or]: 'oder',
};

/**
 * Labels for the field operators, used in the select box.
 */
export const fieldOperatorLabels: Record<FieldArticleRangeFilterOperator, string> = {
  [FieldArticleRangeFilterOperator.Equals]: 'ist',
  [FieldArticleRangeFilterOperator.NotEquals]: 'ist nicht',
  [FieldArticleRangeFilterOperator.NotEmpty]: 'ist gesetzt',
  [FieldArticleRangeFilterOperator.Empty]: 'ist nicht gesetzt',
};
